import React, { useContext, useEffect } from 'react'
import { PlanBuilderContext, Task } from './Plan';
import { Checkbox } from '../ui/checkbox';
import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';
import { Input } from '../ui/input';
import { DeliverableIcon, MilestoneIcon, PackageMilestoneIcon, TaskIcon } from '../ui/Icons/TooltipIcon';

interface FrmDependenciesProps {
    task: Task
    preselectedDependencies?: Array<number>
    onSubmit: (selectedDependencies: Array<number>) => void
}

function FrmDependencies({ task, preselectedDependencies = task.dependencies, onSubmit }: FrmDependenciesProps) {
    const props = useContext(PlanBuilderContext);
    const [selectedDependencies, setSelectedDependencies] = React.useState<Array<number>>(preselectedDependencies);

    const dependencyOptions = GetTasksForDependenciesForm();
    const [filteredOptions, setFilteredOptions] = React.useState<Array<Task>>(dependencyOptions);
    const [searchTerm, setSearchTerm] = React.useState<string>("");

    useEffect(() => {
        setFilteredOptions(dependencyOptions.filter(task => task.name.toLowerCase().includes(searchTerm.toLowerCase())));
    }, [searchTerm, dependencyOptions]);

    function handleCheckboxChange(id: number): void {
        if (selectedDependencies.length > 0 && selectedDependencies.includes(id)) {
            setSelectedDependencies(selectedDependencies.filter((depID) => depID !== id));
        }
        else {
            setSelectedDependencies([...selectedDependencies, id]);
        }
    }

    function GetTasksForDependenciesForm() {
        const allTasks = props.getAllTasks();

        // get a list of tasks that are not the selected task and have the selected task as a dependency
        const dependents: number[] = [];
        props.getDependentTaskIds(task.id, dependents);

        const tasks = allTasks?.filter((task) => !dependents.includes(task.id) && task.id !== props.selectedTaskID);
        return tasks ?? [];
    }

function getTaskIcon(dependencyOption: Task) {
    if (dependencyOption.isMilestone) {
      if (dependencyOption.isDeliverable) {
        return <PackageMilestoneIcon className="m-2" />;
      }
      return <MilestoneIcon className="m-2" />;
    } else if (dependencyOption.isDeliverable) {
      return <DeliverableIcon className="m-2" />;
    } else {
      return <TaskIcon className="m-2" />;
    }
  }

    return (
        <div className="flex flex-col w-[750px]" onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
      }}>
            <Input type="text" className="p-2 mb-2" placeholder="Search tasks..." onChange={(e) => {
                setSearchTerm(e.target.value.toLowerCase());
            }} />
            <div className='flex flex-col max-h-[500px] overflow-y-auto scrollbar'>
                {
                    dependencyOptions.length > 0 ? dependencyOptions.map((dependencyOption) => (
                        // use checkbox component to select dependencies to add to selected task
                        filteredOptions.length > 0 && filteredOptions.includes(dependencyOption) &&
                        <div key={dependencyOption.id} className={`flex items-center justify-between ${dependencyOption.isDeliverable ? "bg-planbuilder-deliverable" : ""}`}><div className="flex items-center">
                            <Checkbox
                                onCheckedChange={() => handleCheckboxChange(dependencyOption.id)}
                                checked={selectedDependencies.includes(dependencyOption.id)}
                            />
                            
                            <div className="flex items-center">
                                {getTaskIcon(dependencyOption)}
                            </div>
                            <span className="ml-2">{dependencyOption.name}</span></div>
                            <span>{format(dependencyOption.startDate, dateformat)} - {format(dependencyOption.finishDate, dateformat)}</span>
                        </div>
                    )) : <span>No other tasks to add as dependencies</span>}
            </div>
            {dependencyOptions.length > 0 && <button className="mt-2 button-default w-full" onClick={() => onSubmit(selectedDependencies)}>Update Dependencies</button>}
        </div>
    )
}

export default FrmDependencies